import {
  Card,
  CardContent,
  LinearProgress,
  Box,
  Container,
  MenuItem,
  InputLabel,
  Select,
  Slider,
} from "@mui/material";
import { useState } from "react";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  animation: ${fadeIn} 1s ease;
`;

const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
  width: 100%;
`;

const Question = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;

  @media (max-width: 767px) {
    font-size: 1rem;
  }
`;

const Subtext = styled.p`
  font-size: 1rem;
  font-weight: 400;

  @media (max-width: 767px) {
    font-size: 0.8rem;
  }
`;

const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

const Option = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 16px;
  font-weight: 400;

  @media (max-width: 767px) {
    font-size: 14px;
  }
`;

const Input = styled.input`
  margin-right: 5px;
  &:hover {
    cursor: pointer;
    border-color: #2196f3;
  }

  &:focus {
    outline: none;
    border-color: #2196f3;
    box-shadow: 0px 0px 3px rgba(33, 150, 243, 0.5);
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  height: 100px;
  padding: 5px;
  font-size: 16px;
  font-weight: 400;
  border-radius: 5px;
  border: 1px solid #ccc;

  @media (max-width: 767px) {
    font-size: 14px;
  }
`;

const SubmitButton = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  border: none;
  background-color: #2196f3;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: #0d8bf2;
  }

  &:focus {
    outline: none;
    background-color: #0d8bf2;
  }

  @media (max-width: 767px) {
    font-size: 14px;
    padding: 8px 16px;
  }
`;

const CardWrapper = styled.div`
  width: 100%;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: translateY(-5px);
  }
`;

const FormBuilder4 = ({ questions, handleSubmit, timerDone }) => {
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});

  const handleInputChange = (questionId, value) => {
    setAnswers({ ...answers, [questionId]: value });
  };

  const handleFormSubmit = (event) => {
    handleSubmit(event, answers);
    console.log(answers);
  };

  return (
    <Container maxWidth="md">
      <Form onSubmit={handleFormSubmit}>
        <CardWrapper>
          <Card>
            <CardContent>
              <QuestionContainer>
                <Question>What is your email address?</Question>
                <OptionContainer>
                  <Option>
                    <Input
                      type="text"
                      name="email"
                      value={answers.name}
                      onChange={(e) =>
                        handleInputChange("10000", e.target.value)
                      }
                    />
                  </Option>
                </OptionContainer>
              </QuestionContainer>
            </CardContent>
          </Card>
        </CardWrapper>
        {Object.values(questions).map((question) => (
          <CardWrapper>
            <Card
              sx={{
                width: "100%",
                backgroundColor: "#white",
                boxShadow:
                  "0px 4px 8px rgba(128, 128, 128, 0.4), 0px 0px 2px rgba(128, 128, 128, 0.4),0px 2px 2px rgba(128, 128, 128, 0.4), 0px 0px 1px rgba(128, 128, 128, 0.4);",
              }}
            >
              <CardContent>
                <QuestionContainer key={question.id}>
                  <Question>{question.text}</Question>
                  {question.subtext && <Subtext>{question.subtext}</Subtext>}
                  {question.type === "multiple-choice" && (
                    <OptionContainer>
                      {question.options.map((option, index) => (
                        <Option key={index}>
                          <Input
                            type="checkbox"
                            name={question.id}
                            value={option}
                            // required={question.required}
                            checked={answers[question.id] === option}
                            onChange={(e) =>
                              handleInputChange(question.id, e.target.value)
                            }
                          />
                          {option}
                        </Option>
                      ))}
                    </OptionContainer>
                  )}
                  {question.type === "radio buttons" && (
                    <OptionContainer>
                      {question.options.map((option, index) => (
                        <Option key={index}>
                          <Input
                            type="radio"
                            name={question.id}
                            value={option}
                            required={question.required}
                            checked={answers[question.id] === option}
                            onChange={(e) =>
                              handleInputChange(question.id, e.target.value)
                            }
                          />
                          {option}
                        </Option>
                      ))}
                    </OptionContainer>
                  )}
                  {question.type === "numeric input" && (
                    <input
                      type="number"
                      placeholder="0"
                      required={question.required}
                    />
                    // <TextArea
                    //   type="number"
                    //   placeholder={question.placeholder}
                    //   required={question.required}
                    //   value={answers[question.id] || ""}
                    //   onChange={(e) =>
                    //     handleInputChange(question.id, e.target.value)
                    //   }
                    // />
                  )}

                  {question.type === "dropdown menu" && (
                    <OptionContainer>
                      <InputLabel id={`${question.id}-label`}>
                        {question.title}
                      </InputLabel>
                      <Select
                        required={question.required}
                        labelId={`${question.id}-label`}
                        id={`${question.id}-select`}
                        // value={value}
                        // onChange={handleChange}
                      >
                        <MenuItem value="">
                          <em>Select an option</em>
                        </MenuItem>
                        {question.options.map((option, index) => (
                          <MenuItem key={index} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </OptionContainer>
                  )}

                  {question.type === "scale" && <Slider />}
                  {question.type === "text field" && (
                    <TextArea
                      placeholder={question.placeholder}
                      required={question.required}
                      value={answers[question.id] || ""}
                      onChange={(e) =>
                        handleInputChange(question.id, e.target.value)
                      }
                    />
                  )}
                  {question.type === "file upload" && (
                    <Input
                      type="file"
                      // name={question._id}
                      // value={option}
                      // required={question.required}
                      // checked={answers[question.id] === option}
                      // onChange={(e) =>
                      //   handleInputChange(question._id, e.target.value)
                      // }
                    />
                  )}
                </QuestionContainer>
              </CardContent>
            </Card>
          </CardWrapper>
        ))}
        <SubmitButton type="submit">Submit</SubmitButton>
      </Form>
    </Container>
  );
};

export default FormBuilder4;
